// store/authInitialState.ts
import { Cabinet, User } from '../../types';

export type CabinetBootstrapStatus = 'idle' | 'loading' | 'ready' | 'error';

/**
 * @french
 * État initial du slice d’authentification.
 */
export const authInitialState = {
  loading: false,
  isAuthenticated: false,
  isAdmin: false,
  user: undefined as User | undefined,
  userCabinetId: undefined as string | undefined,
  userCabinet: undefined as Cabinet | undefined,
  cabinetBootstrapStatus: 'idle' as CabinetBootstrapStatus,
  cabinetBootstrapError: undefined as string | undefined,
  cabinetBootstrapAttempt: 0,
  forgetPasswordEmail: '',
  clientCabinetId: undefined as string | undefined,
  forgetPasswordToken: null as string | null,
  refreshToken: '',
  accessToken: '',
};

/**
 * @french
 * Type dérivé de l’état initial.
 */
export type AuthState = typeof authInitialState;
